<template>
    <div>
        <div v-if="loggedInLoading">
            loading...
        </div>
        <div v-else class="wrapper df fdc jcc aic jcsb">
            <slot/>
        </div>
    </div>

</template>

<script>
import router from '../../router'

export default {
    computed: {
        loggedInLoading () {
            console.warn(this.$store.state)
            if(!this.$store.state.loggedInLoading && !this.$store.state.loggedIn){
                this.router.push('/login')
            }
            return this.$store.state.loggedInLoading
        }
  }
}
</script>
<style scoped>
div{
    /* all: unset; */
}
.wrapper{
    width: 100%;
    max-width: 1280px;
    min-height: 100vh;
}
</style>
